import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Check, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Rsvp() {
  const [name, setName] = useState("");
  const [done, setDone] = useState(false);
  const [total, setTotal] = useState(null);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/rsvp/count`)
      .then((r) => setTotal(r.data.total))
      .catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (name.trim().length < 2) {
      setError("Inserisci il tuo nome per confermare");
      return;
    }
    setError("");
    setSending(true);
    try {
      const r = await axios.post(`${API}/rsvp`, { name: name.trim() });
      setTotal(r.data.total);
      setDone(true);
    } catch {
      setError("Ops, qualcosa è andato storto. Riprova tra poco.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="section" id="rsvp" data-testid="rsvp-section">
      <div className="section-inner">
        <motion.div
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="section-eyebrow">Conferma presenza</div>
          <h2 className="section-title">Ci sarai?</h2>
          <p className="section-lede">
            Fallo sapere a Ginevra: la festa sarà più bella con te.
          </p>

          {done ? (
            <div className="success-panel" data-testid="rsvp-success">
              {Array.from({ length: 8 }, (_, i) => {
                const angle = (i / 8) * Math.PI * 2;
                const dist = 62 + (i % 3) * 16;
                return (
                  <motion.span
                    key={i}
                    className="burst"
                    initial={{ x: 0, y: 0, opacity: 1 }}
                    animate={{
                      x: Math.cos(angle) * dist,
                      y: Math.sin(angle) * dist,
                      opacity: 0,
                    }}
                    transition={{ duration: 1, ease: "easeOut", delay: 0.1 }}
                  />
                );
              })}
              <div className="success-icon">
                <Check size={24} strokeWidth={2} />
              </div>
              <div className="success-title">Grazie, {name.trim()}!</div>
              <div className="success-sub">
                Ti aspettiamo venerdì 20 novembre.
              </div>
            </div>
          ) : (
            <form className="rsvp-form" onSubmit={submit} noValidate>
              <input
                className="rsvp-input"
                data-testid="rsvp-name-input"
                type="text"
                placeholder="Scrivi il tuo nome…"
                value={name}
                maxLength={60}
                autoComplete="name"
                onChange={(e) => setName(e.target.value)}
              />
              <p className="rsvp-error" data-testid="rsvp-error">
                {error}
              </p>
              <button
                className="action-btn rsvp-submit"
                data-testid="rsvp-submit-button"
                type="submit"
                disabled={sending}
              >
                <Send size={14} strokeWidth={1.8} />
                <span>{sending ? "Un momento…" : "Confermo!"}</span>
              </button>
            </form>
          )}

          {total !== null && total > 0 && (
            <div className="rsvp-count" data-testid="rsvp-count">
              <strong>{total}</strong>{" "}
              {total === 1 ? "presenza confermata" : "presenze confermate"}
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
